const THRESHOLD = 300;
const $paginationElem = $(".pagination");
const $window = $(window);
const $document = $(document);
const paginationUrl = $paginationElem.attr("data-pagination-url");
const pagesAmount = $paginationElem.attr("data-pagination-pages");
const dataDiv = $paginationElem.attr("data-div-name");
let currentPage = 1;
let baseEndpoint = paginationUrl + "?page=";

/* initialize pagination */
$paginationElem.hide();
let isPaginating = false;

/* listen to scrolling */
$window.on(
  "scroll",
  _.debounce(function () {
    if (
      !isPaginating &&
      currentPage < pagesAmount &&
      $window.scrollTop() > $document.height() - $window.height() - THRESHOLD
    ) {
      isPaginating = true;
      currentPage++;
      $paginationElem.show();
      $.ajax({
        url: baseEndpoint + currentPage,
      }).done(function (result) {
        $("." + dataDiv).append(result);
        isPaginating = false;
      });
    }
    if (currentPage >= pagesAmount) {
      $paginationElem.hide();
    }
  }, 100)
);
